import { API_ROOT } from 'config/index';
import { AUTH_API } from 'middleware/api';
import withOptions from 'utils/functions/withOptions.util';
import actionType from 'utils/mw/actionType.util';

const ATAG = 'beSendClientStatus';
const AT = actionType(ATAG);

// NOTE: If a client in the salon has the flag 'is_blocked_from_making_ncob: true',
// then in NCOB (when sending the cognito username from page 1 <ServiceSelectionWrap/>),
// the backend should return HTTP 403.
// In that case, we should display the message and hide the services list.

const beSendClientStatus = withOptions(({ salonId, cognitoUserName, data }) => ({
  [AUTH_API]: {
    apiRoot: API_ROOT,
    endpoint: `book-online/appointment/checkclientstatus/${salonId}/`,
    authenticated: true,
    types: [AT.init, AT.pass, AT.fail, AT.done],
    config: {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        cognito_username: cognitoUserName,
      }),
    },
  },
}));

beSendClientStatus.ATAG = ATAG;
beSendClientStatus.AT = AT;

export default beSendClientStatus;
